import { useGlobalContext } from 'apps/student/src/app/Context/GlobalContextProvider';
import { DependencyList, useEffect } from 'react';

type BackHandler = (isHome?: true) => void | Promise<void>;

export const usePalBackNavigationHandlers = (
  backButtonClick: BackHandler,
  deps: DependencyList = []
) => {
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();

  useEffect(() => {
    setSelectedFunction(() => () => backButtonClick());
    setSelectedLogoClickHandler(() => () => backButtonClick(true));

    return () => {
      setSelectedFunction(null);
      setSelectedLogoClickHandler(null);
    };
  }, [backButtonClick, setSelectedFunction, setSelectedLogoClickHandler, ...deps]);
};
